module.exports = __webpack_public_path__ + "static/media/b-sci-major-12_LR.ef9210c7.jpg";